
export default function useRequiredFieldsFilled(values) {
  if (!values) {
    return false;
  }
  if (!values.first_name || !values.last_name) {
    return false;
  }
  return true;
};
